// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { UserResponseSchema } from "./userSchemas";
import { StatusSchema, ResponseMessageSchema } from "./utilitySchemas";

/**
 * DOC: REQUEST SCHEMAS AND TYPES
 */

// DOC: Login
export const LoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});
export type Login = z.infer<typeof LoginSchema>;

// DOC: JWT
export const JwtTokenSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.object({
    id: z.number(),
    name: z.string(),
  }),
  entity: z.object({
    id: z.number(),
    name: z.string(),
    appraiserId:z.string().optional().nullable(),
  }),
  tokenType: z.enum(["auth", "register", "audit"]),
});
export type JwtToken = z.infer<typeof JwtTokenSchema>;

export const RedisDataSchema = JwtTokenSchema.extend({
  refreshToken: z.string(),
});
export type RedisDataDTO = z.infer<typeof RedisDataSchema>;

// DOC: Reset Password Request
export const ResetPasswordRequestSchema = z.object({
  email: z.string().email(),
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

// DOC: Reset Password Validate
export const ResetPasswordValidateSchema = z.object({
  token: z.string().min(10),
});
export type ResetPasswordValidate = z.infer<typeof ResetPasswordValidateSchema>;

// DOC: Reset Password Execute
export const ResetPasswordExecuteSchema = z.object({
  token: z.string().min(10),
  password: z.string().min(8),
  email: z.string().email(),
});
export type ResetPasswordExecute = z.infer<typeof ResetPasswordExecuteSchema>;

// DOC: Reset Password Token
export const ResetPasswordTokenSchema = z.object({
  email: z.string().email(),
  userId: z.number(),
});
export type ResetPasswordToken = z.infer<typeof ResetPasswordTokenSchema>;

/**
 * DOC: RESPONSE SCHEMAS AND TYPES
 */

// DOC: Login
export const LoginResponseSchema = z.object({
  status: StatusSchema,
  data: UserResponseSchema,
  message: ResponseMessageSchema,
});

// DOC: Reset Password Request
export const ResetPasswordRequestResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
});

// DOC: Reset Password Validate
export const ResetPasswordValidateTokenResponseSchema = z.object({
  status: StatusSchema,
  data: z.object({
    email: z.string(),
    userId: z.number(),
    token: z.string(),
  }),
  message: ResponseMessageSchema,
});

// DOC: Reset Password Execute
export const ResetPasswordExecuteResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
  data: z.null(),
});
